import React from 'react';
import { useQuizContext } from 'contexts';
import { QuizTypes } from 'consts/codeMaps';
import { BattleshipBase } from './battleship-quiz/battleship-base';
import { SharpshooterBase } from './sharpshooter/sharpshooter-base';
import { SlideshowQuiz } from './slideshow-quiz/slideshow-quiz';
import { JeopardyBase } from './jeopardy-quiz';

export const Quiz = () => {
    const { quiz } = useQuizContext();

    // TODO - create scenes by QuizType
    switch (quiz.quizTypeId) {
        case QuizTypes.Jeopardy:
            return <JeopardyBase />;

        case QuizTypes.Battleship:
            return (<BattleshipBase />);

        case QuizTypes.Sharpshooter:
            return (<SharpshooterBase />);
    
        case QuizTypes.Slideshow:
        default:
            return (<SlideshowQuiz />);
    }
};
